import { render } from "./ConfirmReq.vue?vue&type=template&id=33ceb2be&scoped=true"
import script from "./ConfirmReq.vue?vue&type=script&lang=js"
export * from "./ConfirmReq.vue?vue&type=script&lang=js"

import "./ConfirmReq.vue?vue&type=style&index=0&id=33ceb2be&scoped=true&lang=css"

import exportComponent from "/kaam/build/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ceb2be"]])

export default __exports__